import { WebRoutes } from "consts/enpoints/web";
import type { Merchant as MerchantType } from "features/ecommerce/types";
import { useOnboardingComplete } from "ui/organizms/ECommerce/Onboarding/common";
import { useOnboardingApplication } from "../../hooks";

export const useComplete = () => {
    const { getApplicationModel } = useOnboardingApplication();

    return useOnboardingComplete<MerchantType.OnboardingApplication>({
        route: WebRoutes.Onboarding.Merchant,
        getApplicationModel
    });
};

export default useComplete;
